import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import { link, paragraphSmall } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  ${SectionWrapperStyles.Inner} {
    --sectionSpacingTop: 16px;
    --sectionSpacingBottom: 16px;
  }
`;
const List = styled.ul `
  ${paragraphSmall};
  margin: 0;

  color: #000;
`;
const Item = styled.li `
  display: inline;

  @media ${until(Device.TabletLarge)} {
    &[data-hidden='true'] {
      ${srOnly};
    }
  }
`;
const LinkSeparator = styled.span `
  content: '/';
  margin: 0 8px;
`;
const ItemLink = styled.a `
  ${link};
  ${fonts.gotham.regular};

  [data-type='engage'] & {
    ${fonts.plusJakarta.regular};
  }

  display: inline;
  white-space: nowrap;
  line-height: 24px;
  padding: 3px 0; // Ensure click area is at least 24px high
  text-decoration-color: transparent;

  &[aria-current='page'] {
    ${fonts.gotham.bold};
  }

  [data-type='engage'] & {
    &[aria-current='page'] {
      ${fonts.plusJakarta.bold};
    }
  }

  &:not([aria-current='page']):focus-visible,
  &:not([aria-current='page']):hover {
    text-decoration-color: currentColor;
  }
`;
const BreadCrumbsStyles = {
    Container,
    List,
    LinkSeparator,
    Item,
    ItemLink,
};
export default BreadCrumbsStyles;
